import { Controller } from 'stimulus';

import $ from 'jquery';
import sortable from 'jquery-ui/ui/widgets/sortable';

export default class extends Controller {
  connect() {
    $(this.element).sortable()
  }
}
